import { useGroupsConfig } from '@/shared/features/groups/context/groups-config-context';
import { TGroupsApi } from '@/shared/features/groups/context/groups-config-context.types';

// Single entry point for the groups API. The hooks below are config-backed
// (app-injected); the rest is re-exported from enhanced-groups-api.
export {
  groupsApi,
  useDeleteResourceGroupMutation,
  useReadAllResourceGroupsWithoutPermissionChecksQuery,
  useReadResourceGroupsToBuildTreeQuery,
  useReadGroupedAssetsCountQuery,
  useReadGroupedAssetCountsQuery,
  useReadUngroupedAssetsCountQuery,
} from '@/shared/redux/api/assets/groups/enhanced-groups-api';
export type { TResourceGroupsApi } from '@/shared/redux/api/assets/groups/enhanced-groups-api';

export const useReadAllResourceGroupsQuery: TGroupsApi['useReadAllResourceGroupsQuery'] =
  (...args) => useGroupsConfig().api.useReadAllResourceGroupsQuery(...args);

export const useReadResourceGroupByIdQuery: TGroupsApi['useReadResourceGroupByIdQuery'] =
  (...args) => useGroupsConfig().api.useReadResourceGroupByIdQuery(...args);

export const useReadResourceGroupNameByIdQuery: TGroupsApi['useReadResourceGroupNameByIdQuery'] =
  (...args) => useGroupsConfig().api.useReadResourceGroupNameByIdQuery(...args);

export const useReadResourceGroupNamesForRoleRowQuery: TGroupsApi['useReadResourceGroupNamesForRoleRowQuery'] =
  (...args) =>
    useGroupsConfig().api.useReadResourceGroupNamesForRoleRowQuery(...args);

export const useCreateResourceGroupMutation: TGroupsApi['useCreateResourceGroupMutation'] =
  (...args) => useGroupsConfig().api.useCreateResourceGroupMutation(...args);

export const useUpdateResourceGroupMutation: TGroupsApi['useUpdateResourceGroupMutation'] =
  (...args) => useGroupsConfig().api.useUpdateResourceGroupMutation(...args);

export const useLazyReadResourceGroupNameByIdQuery: TGroupsApi['useLazyReadResourceGroupNameByIdQuery'] =
  (...args) =>
    useGroupsConfig().api.useLazyReadResourceGroupNameByIdQuery(...args);

export const useReadSubGroupsForResourceGroupQuery: TGroupsApi['useReadSubGroupsForResourceGroupQuery'] =
  (...args) =>
    useGroupsConfig().api.useReadSubGroupsForResourceGroupQuery(...args);
